import * as yup from 'yup';

export const schemaClientForm = yup.object().shape({
  client_id: yup.string().required('Cliente obrigatório'),
  professional_id: yup.string().required('Profissional obrigatório'),
  form_id: yup.string().required('Convênio obrigatório'),
});
